import { atom } from 'jotai';

export type VoucherAtom = {
  code: string;
  discount: number;
  description?: string;
} | null;

export const voucherInitialValue: VoucherAtom = null;

export const voucherAtom = atom<VoucherAtom>(voucherInitialValue);
